module.exports = __webpack_public_path__ + "static/media/pricingPackageDemo.0a1aafec.gif";